/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import './index.less';

interface Props {
  // 提示文案
  text: string;
  // 图标链接
  icon: string;
  retry: boolean;
}

function reload() {
  window.location.reload();
}

export default function Empty(props: Props) {
  const { text, icon, retry = false } = props;
  return (
    <div className="empty">
      <div className="empty-msg-wrap">
        <img className="empty-img" src={icon} alt="" />
        <p className="empty-msg">{text}</p>
        {retry ? (
          <a className="retry" onClick={() => reload()}>
            点击刷新
          </a>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
